import type { IntelligenceRequest } from '../domain/intelligenceRequest/IntelligenceRequest';
import qs from 'qs';
import { useState } from 'react';
import { useApi } from '../services/api';
import { log } from '../utils/log';

export function useIntelligenceRequests() {
  const api = useApi();

  const [intelligenceRequests, setIntelligenceRequests] = useState<IntelligenceRequest[]>([]);
  const [loading, setLoading] = useState(false);

  const getIntelligenceRequests = async (
    params?: Record<string, any> & {
      industries?: string[];
      engagementType?: string[];
      authorId?: number;
      isPrivate?: boolean;
      excludeUserId?: number;
    },
    orderBy?: string,
    orderDirection?: 'ASC' | 'DESC',
  ) => {
    const baseParams = { ...(params || {}) } as Record<string, any>;

    const queryParams = {
      ...baseParams,
      ...(orderBy ? { orderBy } : {}),
      ...(orderDirection ? { orderDirection } : {}),
    };

    setLoading(true);
    try {
      const res = await api.get('/intelligence-request', {
        params: queryParams,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat' }),
      });
      const list = Array.isArray(res?.data) ? res.data : res?.data?.data || [];
      setIntelligenceRequests(list as IntelligenceRequest[]);
      return list;
    } catch (error) {
      log.error('[IR_HOOK] Error fetching IRs:', error);
      setIntelligenceRequests([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  return {
    intelligenceRequests,
    loading,
    getIntelligenceRequests,
    reload: getIntelligenceRequests,
  };
}
